import { useSelector } from "react-redux";
import Notification from "../components/Notification";
import { useMemo } from "react";
import BackgroundPatterns from "../utils/BackgroundPatterns/Backgroundpatterns";

export default function PaymentLayout({ title, children }) {
  const notification = useSelector((state) => state.notification);
  
  // ⭐ Ambil style dari Redux
  const { 
    primary_color, 
    logo_url, 
    primary_text_color,
    background_type = 'cakes', // default: cakes, options: tech, cakes, dots, grid, geometric, custom
    background_custom = null,
    background_custom_url = null, // URL untuk custom background
  } = useSelector((state) => state.style);

  if(process.env.REACT_APP_DEBUG){
    console.log('PaymentLayout styles:', { 
      primary_color, 
      logo_url, 
      primary_text_color, 
      background_type,
      background_custom,
      background_custom_url
    });
  }

  // ⭐ Initialize BackgroundPatterns dengan primary_color
  const backgroundPatterns = useMemo(
    () => new BackgroundPatterns(primary_color),
    [primary_color]
  );

  // ⭐ Get pattern berdasarkan background_type
  // Akan return null jika type adalah 'custom'
  const selectedPattern = useMemo(
    () => backgroundPatterns.getPattern(background_type, background_custom_url),
    [backgroundPatterns, background_type, background_custom_url]
  );

  // ⭐ Background style - akan include backgroundImage jika custom
  const backgroundStyle = useMemo(
    () => backgroundPatterns.getBackgroundStyle(background_type, background_custom_url),
    [backgroundPatterns, background_type, background_custom_url]
  );

  return (
    <div 
      className="min-h-screen flex items-center justify-center p-0 md:p-4"
      style={backgroundStyle}
    >
      {/* ⭐ SVG Pattern Layer - hanya render jika bukan custom */}
      {selectedPattern && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: 'none',
          zIndex: 0
        }}>
          {selectedPattern}
        </div>
      )}

      <div className="w-full md:max-w-[480px] mx-auto md:rounded-lg overflow-hidden shadow-md relative z-10">
        
        {/* Header dengan dynamic primary color */}
        <div 
          className="relative text-white p-6 flex items-center gap-4"
          style={{ 
            backgroundColor: primary_color, 
            color: primary_text_color
          }}
        >
          <h1 className="text-4xl font-bold flex-1">{title}</h1>

          {/* ⭐ Logo merchant jika ada */}
          {logo_url && (
            <img 
              src={logo_url} 
              alt="Merchant Logo" 
              className="w-14 h-14 object-contain flex-shrink-0"
            />
          )}
        </div>

        {/* Notifikasi */}
        <Notification 
          message={notification.message} 
          type={notification.type} 
          title={notification.title} 
        />

        {/* Content */}
        <div className="bg-white p-6 space-y-4">
          {children}
        </div>
      </div>
    </div>
  );
}